import { styled } from '@mui/material';
import { COLORS } from '~/data/ui/colors';

export const listStyles = {
  display: 'flex',
  gap: '8px',
  alignItems: 'center',
};
export const listItemsStyles = {
  width: 'unset',
  display: 'flex',
  fontSize: '16px',
  '& a:visited': {
    textDecoration: 'none',
    color: COLORS.black.main,
  },
  '& a': {
    textDecoration: 'none',
    color: COLORS.black.main,
  },
  '&:last-of-type': {
    fontFamily: 'EricaSansFOT,GillSans',
    fontWeight: '800',
  },
};

export const currentItemStyles = {
  fontSize: '16px',
  cursor: 'default',
  color: COLORS.black.main,
};

export const StyledArrow = styled('svg')({
  maxWidth: '7px',
});
